module.exports = {
      id: "gallery-whitebg-usage",
      viewBox: "0 0 90 90",
      url: "/" + "sprite-830c6fc89c6e575b53718d760c90aee8.svg#gallery-whitebg",
      toString: function () {
        return this.url;
      }
    }